import {Component, ElementRef, inject, Signal, signal, viewChild, WritableSignal} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ControlStore} from 'frontier/nucleus';
import {ReportingService} from '../../../api/generated';

@Component({
  selector: 'app-dashboard-v2',
  standalone: true,
  imports: [],
  templateUrl: './dashboard-v2.component.html',
  styleUrl: './dashboard-v2.component.scss',
})
export class DashboardV2Component {
  private _reportingService: ReportingService = inject(ReportingService);
  private _sanitizer: DomSanitizer = inject(DomSanitizer);
  private _controlStore: ControlStore = inject(ControlStore);

  sanitizedUrl: WritableSignal<SafeResourceUrl> = signal<SafeResourceUrl>(null);
  iframeRef: Signal<ElementRef<HTMLIFrameElement> | undefined> = viewChild<ElementRef<HTMLIFrameElement>>('frame');

  constructor() {
    const url: string = `${this._reportingService.configuration.basePath}/intern/api/reporting/dashboard/`;
    this.sanitizedUrl.set(this._sanitizer.bypassSecurityTrustResourceUrl(url));

    this._controlStore.tenantChanged$
      .pipe(takeUntilDestroyed())
      .subscribe((): void => {
        this.iframeRef()?.nativeElement.contentWindow?.location.reload();
      });
  }
}
